import {bootstrap, container} from './include/services.js';
import {start} from './include/start.js';

function boot() {
    start();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {once: true});
} else {
    boot();
}

window.bootstrap = bootstrap;
window.container = container;
